<template>
	<datatable
		ref="datatable"
		:user="user"
		:isAuth="isAuth">
	</datatable>
</template>

<script>
	import Create from './../views/Create.vue'
	//import Edit from './../views/Edit.vue'
	import Datatable from './Datatable.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'create': Create,
			//'edit': Edit,
			'datatable': Datatable,
		},
		data () {
			return {
			}
		},
		methods: {
			reload() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/products/views/Index.vue